/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

/** @module MatchModule */

import {
    IStringMatch,
    StringOperation,
} from 'generated-types';

import { StringMatch } from 'object-types';
import { PathOrQueryMatchBaseConfigItem } from './path-or-query-match-base.config-item';

interface IStringMatchExtended extends IStringMatch {
    match_str?: string[];
    string_group_refs?: string[];
    match_decoded_string?: boolean
}

/**
 * @description  StringMatch ConfigItem class.
 * @author Akul Aggarwal
 */
export class StringMatchConfigItem extends PathOrQueryMatchBaseConfigItem<IStringMatchExtended> {
    public static ajsDependencies = ['schemaService'];

    constructor(args = {}) {
        super({
            objectType: StringMatch,
            ...args,
        });

        const schemaService = this.getAjsDependency_('schemaService');

        this.operationLabels = schemaService.getEnumValueLabelsHash('StringOperation');
    }

    /**
     * Getter function for the config to override the message default.
     */
    /** @override */
    // eslint-disable-next-line no-underscore-dangle
    public get defaultConfigOverride_(): Partial<IStringMatchExtended> {
        return {
            match_criteria: StringOperation.BEGINS_WITH,
        };
    }

    /** @override */
    public canFlatten(): boolean {
        const {
            match_str: matchStr,
            string_group_refs: stringGroupRefs,
        } = this.config;

        return matchStr?.length > 0 || stringGroupRefs?.length > 0;
    }
}
